






import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class ModalTextLinkExtension extends Vue {
  @Prop() name!: string;
  @Prop() disabled!: boolean;

  show() {
    if (!this.disabled) {
      if (window.innerWidth >= 480) {
        this.$modal.show(`${this.name}_pc`);
      } else {
        this.$modal.show(`${this.name}_sp`);
      }
    }
  }
}
